import {
  IntegrationAddRequest,
  IntegrationConnection,
} from '@aibees/elephant/types/integration';
import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient, useBaseMutation } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { INTEGRATION_API_PREFIX } from './constants';
import { useBrowseIntegrationApi } from './use-browse-integration-api';
import { useBrowseIntegrationCountApi } from './use-browse-integration-count-api';

export function useAddIntegrationMutationApi() {
  const workspace = useWorkspace();

  return useBaseMutation<IntegrationAddRequest, IntegrationConnection>(
    {
      url: INTEGRATION_API_PREFIX.replace(':wid', String(workspace?.id)),
      method: HttpMethod.post,
    },
    {
      onSuccess() {
        baseQueryClient.invalidateQueries([useBrowseIntegrationCountApi.name]);
        baseQueryClient.invalidateQueries([useBrowseIntegrationApi.name]);
      },
    }
  );
}
